const CH_DESCRIPTION = {
    CHFlex: "Flex",
    CHFixed: "Fixed"
};

export const getDescription = (accountType) =>
    CH_DESCRIPTION[accountType] || accountType;

export const CH_TYPES = ["CoreHealth", "CHFlex", "CHFixed"];
export const FIXED_TYPES = ["Fixed", "CHFixed"];
export const FLEX_TYPES = ["Flex", "CHFlex"];

export const provincesTaxRates = {
    AB: 0.05,
    BC: 0.05,
    MB: 0.05,
    NB: 0.15,
    NL: 0.15,
    NT: 0.05,
    NS: 0.15,
    NU: 0.05,
    ON: 0.13,
    PE: 0.15,
    QC: 0.05,
    SK: 0.05,
    YT: 0.05
};

export const accountTypeHeaders = {
    HSA: "Health Spending Account",
    LSA: "Lifestyle Spending Account",
    CoreHealth: "CoreHealth+ Account",
    Flex: "Flexible Spending Account",
    CHFlex: "CoreHealth+ / Flex Account",
    Fixed: "Fixed Spending Account",
    CHFixed: "CoreHealth+ / Fixed Account"
}

const BASE_COVERAGE = [
    "Dental (Basic & Major)",
    "Orthodontics",
    "Prescription Drugs",
    "Paramedical Services",
    "Vision care",
    "Physiotherapy",
    "Chiropractor"
];

const LSA_NOTE =
    "LSA expenses are chosen on the master application at time of enrollment.";

export const accountTypeCoverageSummaries = {
    HSA: BASE_COVERAGE,
    LSA: [LSA_NOTE],
    CoreHealth: BASE_COVERAGE,
    Flex: [...BASE_COVERAGE, LSA_NOTE],
    CHFlex: [...BASE_COVERAGE, LSA_NOTE],
    Fixed: [...BASE_COVERAGE, LSA_NOTE],
    CHFixed: [...BASE_COVERAGE, LSA_NOTE]
};

export const safeParse = (obj, key, subKey) => {
    return obj?.[key]?.[subKey] !== undefined ? parseInt(obj[key][subKey], 10) || 0 : 0;
};


export const getImageBase64 = async (url) => {
    const response = await fetch(url);
    const blob = await response.blob();
    return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onloadend = () => resolve(reader.result);
        reader.onerror = reject;
        reader.readAsDataURL(blob);
    });
};

export const groupInsuranceCoverageData = [
    {
        coverage: "Life Insurance",
        single: "$15,000",
        family: `$15,000 [Employee]\n$10,000 [Spouse]\n$5,000 [per Child]`
    },
    {
        coverage: "Accidental Death and Dismemberment",
        single: "$60,000",
        family: "$60,000 [Employee]"
    },
    {
        coverage: "Critical Illness",
        single: "$10,000",
        family: "$10,000 [Employee]"
    },
    {
        coverage: "Travel Emergency Medical (up to 60 days of travel)",
        single: "$2,000,000",
        family: "$2,000,000 [Each Family Member]"
    },
    {
        coverage: "Excess Medical Costs (over $2,500) (Stop Loss Coverage)",
        single: "$250,000",
        family: "$250,000"
    },
    {
        coverage: "Monthly Premium",
        single: "$29.99/month\n+ any HSA usage",
        family: "$39.99/month\n+ any HSA usage"
    }
];

export const generateGroupInsuranceTable = () => {
    // header row
    const headerRow = [
        { text: "Coverage", bold: true },
        { text: "Single", bold: true },
        { text: "Family", bold: true }
    ];

    // data rows with consistent structure
    const dataRows = groupInsuranceCoverageData.map((item) => [
        { text: item.coverage },
        { text: item.single },
        { text: item.family }
    ]);

    return [headerRow, ...dataRows];
}

